// extracted by mini-css-extract-plugin
module.exports =  {"left":"_93444fe79c--left--CqYKC","right":"_93444fe79c--right--xbcNy","content":"_93444fe79c--content--KT1U5"};